import Swal from "sweetalert2";
import { deleteConfirmModal } from "../../../helpers/DeleteValidate";
import {
    Call,
    CallWithFormData,
    mergeFormData,
    objectToFormData,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";
import { startStudentSetActive } from "../../actions/students/students";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    notes: [],
};

export const NotesAcademicRecord = createSlice({
    name: "notesAcademicRecord",
    initialState,
    reducers: {
        setData: (state, action) => {
            state.notes = action.payload ?? [];
        },
        clearData: (state, action) => {
            state.notes = [];
        },
    },
});

export const { setData, clearData } = NotesAcademicRecord.actions;

export default NotesAcademicRecord.reducer;

//* Actions
export const startShow = (academic_record_id) => {
    return async (dispatch, getState) => {
        dispatch(startUILoading());

        const resp = await Call(`operators/notes/${academic_record_id}`, "GET");

        if (resp.success) {
            dispatch(setData(resp.success));
        }

        dispatch(stopUILoading());
    };
};

export const startCreate = (values) => {
    return async (dispatch, getState) => {
        dispatch(startUILoading());

        let data = objectToFormData(values);
        data.delete("files");

        const formData = new FormData();

        if (values?.files) {
            values.files.forEach((file, index) => {
                formData.append(`files[${index}]`, file);
            });
        }
        const resp = await CallWithFormData(
            `operators/notes`,
            "POST",
            mergeFormData(data, formData)
        );

        if (resp.success) {
            dispatch(setData(resp.success));
            Swal.fire({
                title: "Éxito",
                text: "Nota añadida correctamente.",
                toast: true,
                position: "bottom-end",
                icon: "success",
            });
        }

        dispatch(stopUILoading());
    };
};

export const startDelete = (note_id) => {
    return async (dispatch) => {
        await deleteConfirmModal(async () => {
            dispatch(startUILoading());

            const resp = await Call(`operators/notes/${note_id}`, "DELETE");
            if (resp.success) {
                dispatch(setData(resp.success));
                Swal.fire({
                    title: "Éxito",
                    text: "Nota eliminada.",
                    toast: true,
                    position: "bottom-end",
                    icon: "success",
                });
            }

            dispatch(stopUILoading());
        });
    };
};
